import { RegisterAndActivateCouponConnectorApollo } from '@front-activerse/common-components';
import { UserDataConnectorApollo } from '@front-activerse/common-components';
import DeveloperOptionsComponent from './DeveloperOptionsComponent';

const DeveloperOptionsContainer = () => {
  const serverEnv = import.meta.env.VITE_REACT_APP_ENV || 'prod';

  if (serverEnv === 'prod') {
    return null;
  }

  return (
    <RegisterAndActivateCouponConnectorApollo>
      {({ ...registerAndActivateCoupon }) => (
        <UserDataConnectorApollo>
          {({ ...userDataOnDemand }) => (
            <DeveloperOptionsComponent {...registerAndActivateCoupon} {...userDataOnDemand} />
          )}
        </UserDataConnectorApollo>
      )}
    </RegisterAndActivateCouponConnectorApollo>
  );
};

export default DeveloperOptionsContainer;
